import React from 'react'
import "./newteam.css";
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaGithub} from 'react-icons/fa'

import lovkesh from "../../assets/POR/lovkesh1.jpg"
import hardik from "../../assets/POR/hardik.png"
import garima from "../../assets/tech/Garima Dua- Execomm.jpeg"
import pranav from "../../assets/tech/Pranav Singh Kanwar- Execomm.jpeg"
import Priyanshu from "../../assets/tech/Priyanshu -Execomm.jpg"
import sumukh from "../../assets/tech/sumukh jain-execomm.jpg"

const Newteam = () => {
  return (
    <>
    <h2 className="main-title">Tech Team</h2>
    <div class="nnn">
    <div className="cont">
    
        <div className="cards">
          <div className="imgbox">
            <img src={lovkesh} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Lovkesh Patel <br /><span>web developer</span></h2>
              <ul className="social_media">
                <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                <li><a href="#"><FaGithub className="i" /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={hardik} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Hardik Chhabra <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                <li><a href="#"><FaGithub className="i" /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={garima} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Garima Dua <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                <li><a href="#"><FaGithub className="i" /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={pranav} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Priyanshu <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                <li><a href="#"><FaGithub className="i" /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={Priyanshu} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Pranav Singh <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                <li><a href="#"><FaGithub className="i" /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={sumukh} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Sumukh Jain <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                <li><a href="#"><FaGithub className="i" /></a></li>
              </ul>
            </div>
          </div>
        </div>

    

      </div>
      </div>
    </>
  )
}

export default Newteam